<template>
<imag class="user-image" :src="imageUrl" :size="size" :hasBackground="true" :alt="alt">
<div class="active-indicator" v-if="state" :class="state"></div>
</imag>
</template>

<script>
import Imag from '@/components/general/image'
import { mapGetters } from 'vuex'

export default {
  components: { Imag },
  computed: {
    ...mapGetters('users', [
      'profilePictureUrl',
      'imageUrlForUser'
    ]),
    imageUrl () {
      if (this.brandImageUrl) return this.brandImageUrl
      if (this.user) { return this.imageUrlForUser(this.user) }
      return this.profilePictureUrl
    }
  },
  props: {
    size: {
      type: String,
      default: 'is-96x96'
    },
    alt: {
      type: String
    },
    user: {
      type: Object,
      default: null
    },
    state: {
      type: String,
      default: null
    },
    brandImageUrl: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

.user-image {
  flex-shrink: 0;
  & > img {
    background-color: #fafafa;
  }
  display: flex;
}

.image img {
  background-color: #fafafa;
}

.active-indicator {
  width: 40%;
  height: 40%;
  border: solid 2px #f9f9f9;
  border-radius: 50%;
  position: absolute;
  right: -7%;
  top: -7%;
}
.active-indicator.active {
  background-color: $brand-primary;
}
.active-indicator.offline {
  background-color: $gray;
}
.active-indicator.inactive {
  background-color: $amber;
}
</style>



// WEBPACK FOOTER //
// src/components/general/user-image.vue